import { TrackedNav } from '@objectiv/tracker-react';
import { BaseLink } from '~components/BaseLink';
import clsx from 'clsx';

import * as styles from './TocDesktop.module.css';

type TocDesktopProps = {
  headings: string[];
  activeSectionIndex: number;
  onSelect: (index: number) => void;
  className?: string;
};

export const TocDesktop: React.FC<TocDesktopProps> = ({ headings, activeSectionIndex, onSelect, className }) => (
  <aside className={clsx(styles.tocDesktop, className)}>
    <TrackedNav objectiv={{ id: 'toc-desktop' }} className={styles.toc}>
      {headings.map((heading, index) => (
        <BaseLink
          key={heading}
          href=''
          className={clsx(styles.link, activeSectionIndex === index && styles.active)}
          onClick={(event) => {
            event.preventDefault();
            onSelect(index);
          }}
        >
          {heading}
        </BaseLink>
      ))}
    </TrackedNav>
  </aside>
);
